export const atrustRegisterFormStructure = [
  {
    element: 'Label',
    static: true,
    label: 'address_dialog_personalInfo',
    tooltip: 'qes_registration_readonly_fields_hint',
    notSelectable: true,
    id: 'personalInfo'
  },
  {
    element: 'TextInput',
    label: 'address_dialog_firstName',
    id: 'firstName',
    layoutSize: 6
  },
  {
    element: 'TextInput',
    label: 'address_dialog_lastName',
    id: 'lastName',
    layoutSize: 6
  },
  {
    element: 'DatePicker',
    label: 'address_dialog_dateOfBirth',
    dateFormat: 'dd.MM.yyyy',
    timeFormat: 'hh:mm aa',
    showDateSelect: true,
    id: 'dateOfBirth',
    layoutSize: 6,
    validate: {
      dateOfBirth18: true
    }
  },
  {
    element: 'Label',
    static: true,
    label: 'address_dialog_contactInformation',
    notSelectable: true,
    id: 'contactInformation'
  },
  {
    element: 'TextInput',
    label: 'address_dialog_email',
    id: 'email',
    validationRule: 'EMAIL',
    layoutSize: 6
  },
  {
    element: 'TextInput',
    label: 'address_dialog_phone',
    id: 'phone',
    validationRule: 'PHONE',
    layoutSize: 6
  },
  {
    element: 'Label',
    static: true,
    label: 'address_dialog_address',
    notSelectable: true,
    id: 'address'
  },
  {
    element: 'TextInput',
    label: 'address_dialog_street',
    id: 'street',
    layoutSize: 8
  },
  {
    element: 'TextInput',
    label: 'address_dialog_houseNumber',
    id: 'houseNumber',
    layoutSize: 4
  },
  {
    element: 'TextInput',
    label: 'address_dialog_zipcode',
    id: 'zipcode',
    layoutSize: 2
  },
  {
    element: 'TextInput',
    label: 'address_dialog_city',
    id: 'city',
    layoutSize: 4
  },
  {
    element: 'Dropdown',
    label: 'address_dialog_countryCode',
    layoutSize: 6,
    id: 'countryCode',
    options: [
      {
        id: 'a8a4267d-0e37-e88a-a7fc-b17efa3a046b',
        label: 'Afghanistan',
        customId: 'af'
      },
      {
        id: '61ef9fe5-5a47-6f8c-a076-b085fc5685ed',
        label: 'Ägypten',
        customId: 'eg'
      },
      {
        id: 'b5eab352-f8c0-ab25-2472-dd7d01df696c',
        label: 'Albanien',
        customId: 'al'
      },
      {
        id: 'd6b06650-42ed-e157-e9c1-f4c9c24ea276',
        label: 'Algerien',
        customId: 'dz'
      },
      {
        id: '0914ae5a-a1f1-eb75-f1fa-6947d20f55ec',
        label: 'Andorra',
        customId: 'ad'
      },
      {
        id: 'c733451c-9f43-ff37-4675-9e0f9a3e2bb1',
        label: 'Angola',
        customId: 'ao'
      },
      {
        id: 'dc933479-ce31-e7ce-a803-492ef719cff9',
        label: 'Antigua und Barbuda',
        customId: 'ag'
      },
      {
        id: '7b2eca3e-1780-6130-d077-c207419560bd',
        label: 'Äquatorialguinea',
        customId: 'gq'
      },
      {
        id: '359ad182-0915-6522-68b9-481a76bd2e69',
        label: 'Argentinien',
        customId: 'ar'
      },
      {
        id: 'b96b8883-84a6-72ec-56ac-7415a991fedb',
        label: 'Armenien',
        customId: 'am'
      },
      {
        id: '85592f0b-20c5-fdb6-72ff-456269c2d892',
        label: 'Aserbaidschan',
        customId: 'az'
      },
      {
        id: '8e1c1032-b686-6884-4c53-5de96cfe7804',
        label: 'Äthiopien',
        customId: 'et'
      },
      {
        id: '120b31ac-2be5-2f6b-5f60-36aec2930a65',
        label: 'Australien',
        customId: 'au'
      },
      {
        id: '691df3f5-8202-f1ef-40d2-61e0d57562aa',
        label: 'Bahamas',
        customId: 'bs'
      },
      {
        id: '7b9ee06b-10e5-1012-bb9a-447acc240e7f',
        label: 'Bahrain',
        customId: 'bh'
      },
      {
        id: 'c254a1d1-413d-e9ae-dc06-1b87be793128',
        label: 'Bangladesch',
        customId: 'bd'
      },
      {
        id: '902d2ffc-b7ab-e143-6243-4071fc85092a',
        label: 'Barbados',
        customId: 'bb'
      },
      {
        id: '065ddb02-7ebc-d463-8ead-881a53df9623',
        label: 'Belgien',
        customId: 'be'
      },
      {
        id: '27097dfc-9a53-c764-b0bb-a477107c53c6',
        label: 'Belize',
        customId: 'bz'
      },
      {
        id: '595b018c-95a8-5572-5948-2491dc8c230a',
        label: 'Benin',
        customId: 'bj'
      },
      {
        id: 'b0fee465-2573-6f58-9c59-d3bb5cc8582c',
        label: 'Bhutan',
        customId: 'bt'
      },
      {
        id: '6d424800-c6cb-3844-5eba-87d4c2f9350b',
        label: 'Bolivien',
        customId: 'bo'
      },
      {
        id: '40c4f23b-1982-6d7b-7102-044b0351c9d3',
        label: 'Bosnien und Herzegowina',
        customId: 'ba'
      },
      {
        id: '7ce21c4f-55e1-c120-a14f-769878d7caee',
        label: 'Botswana',
        customId: 'bw'
      },
      {
        id: '844c1914-aa19-8792-ab61-68e73e2d1d83',
        label: 'Brasilien',
        customId: 'br'
      },
      {
        id: 'f93f6717-ea23-d6c9-c01e-99b1e237f150',
        label: 'Brunei',
        customId: 'bn'
      },
      {
        id: 'ce54ed63-bb98-e65c-a91b-3fc2b3081791',
        label: 'Bulgarien',
        customId: 'bg'
      },
      {
        id: '363b5641-80d5-9692-0838-0a8dbb0fdc42',
        label: 'Burkina Faso',
        customId: 'bf'
      },
      {
        id: 'b0b36ad1-825e-26cc-7417-e8bb15d05c79',
        label: 'Burundi',
        customId: 'bi'
      },
      {
        id: 'a1dbac53-d0ee-7b6f-8114-44e1c5c60a3e',
        label: 'Chile',
        customId: 'cl'
      },
      {
        id: 'd0bd7ef3-6e32-def2-997a-ce957ec4f07b',
        label: 'China',
        customId: 'cn'
      },
      {
        id: '36be8495-38d0-8775-a5ec-8eafbae0e5ca',
        label: 'Costa Rica',
        customId: 'cr'
      },
      {
        id: 'd78c726c-e287-cb4e-4330-694421aa7530',
        label: 'Dänemark',
        customId: 'dk'
      },
      {
        id: '1dd7e61b-835f-eb04-7d50-163ad385c529',
        label: 'Deutschland',
        customId: 'de'
      },
      {
        id: '9d05b7a1-0410-a59b-5a52-00837ddb5e5e',
        label: 'Dominica',
        customId: 'dm'
      },
      {
        id: 'd49a7442-5108-90e3-7be0-e948bba7448f',
        label: 'Dominikanische Republik',
        customId: 'do'
      },
      {
        id: '85717960-9c23-b24f-a7e8-fd42543b6ae9',
        label: 'Dschibuti',
        customId: 'dj'
      },
      {
        id: '846143f7-da55-56c6-1461-804b7a8bfb2f',
        label: 'Ecuador',
        customId: 'ec'
      },
      {
        id: '2b4a16f8-a19f-a9ac-6f41-1a151db76360',
        label: 'El Salvador',
        customId: 'sv'
      },
      {
        id: 'dd1f30a7-8258-3c9d-259c-0355d45b66bd',
        label: 'Elfenbeinküste',
        customId: 'ci'
      },
      {
        id: '43e84190-6903-02d8-33d2-03b2396f77e2',
        label: 'Eritrea',
        customId: 'er'
      },
      {
        id: '11ccd634-2e09-e946-8ef3-ef3086153698',
        label: 'Estland',
        customId: 'ee'
      },
      {
        id: 'daa060df-6c07-b4f0-b476-d3c04d29c092',
        label: 'Eswatini',
        customId: 'sz'
      },
      {
        id: '52a77f21-e562-543a-474f-f399109b2e64',
        label: 'Fidschi',
        customId: 'fj'
      },
      {
        id: '8b5d0f4a-115f-aa8c-3650-394470a58537',
        label: 'Finnland',
        customId: 'fi'
      },
      {
        id: '4ebe4e3a-2003-22f0-6516-90337b9fd3cb',
        label: 'Frankreich',
        customId: 'fr'
      },
      {
        id: 'b613bbf5-6881-fd22-15c6-92a145f962b3',
        label: 'Gabun',
        customId: 'ga'
      },
      {
        id: '74fc45cd-75db-9741-00bf-8f97708b2502',
        label: 'Gambia',
        customId: 'gm'
      },
      {
        id: '573dfa85-24cf-095f-caea-5fa8227bb444',
        label: 'Georgien',
        customId: 'ge'
      },
      {
        id: 'd011ab6c-e96f-3722-c732-35ee3034f6cc',
        label: 'Ghana',
        customId: 'gh'
      },
      {
        id: 'c0a4e489-9c08-6bb7-44af-4f7b703cfc0c',
        label: 'Grenada',
        customId: 'gd'
      },
      {
        id: 'c7eecd57-0af5-850e-dbfd-245eb7db41d3',
        label: 'Griechenland',
        customId: 'gr'
      },
      {
        id: '0b339899-8a4e-3ac5-12c8-9c56f82d6d4c',
        label: 'Guatemala',
        customId: 'gt'
      },
      {
        id: '7ee417e3-3fad-aaae-6305-7b2459541625',
        label: 'Guinea',
        customId: 'gn'
      },
      {
        id: 'f5350112-d950-0716-5895-de82a7c7ed5f',
        label: 'Guinea-Bissau',
        customId: 'gw'
      },
      {
        id: '6cebb49c-2ccd-ca63-0241-90fb22216b43',
        label: 'Guyana',
        customId: 'gy'
      },
      {
        id: '004508cd-f95f-a479-612a-a0bb53aff152',
        label: 'Haiti',
        customId: 'ht'
      },
      {
        id: 'ba4da0cf-3f9d-cc3f-ab39-0a81478b046d',
        label: 'Honduras',
        customId: 'hn'
      },
      {
        id: 'b5c46422-6652-6f36-3b93-a0d48f5689e1',
        label: 'Indien',
        customId: 'in'
      },
      {
        id: 'f3fd7fd0-a87e-5d31-9f5d-d9c5a587eb5f',
        label: 'Indonesien',
        customId: 'id'
      },
      {
        id: '97d83c94-9b8d-377a-e7e3-8231248e3ba2',
        label: 'Irak',
        customId: 'iq'
      },
      {
        id: '6576d377-a231-07d7-abea-b1424f6a7cc4',
        label: 'Iran',
        customId: 'ir'
      },
      {
        id: '89c04be0-7fa5-0d65-576b-890dc9727f1c',
        label: 'Irland',
        customId: 'ie'
      },
      {
        id: '593007e0-567a-53a5-45ea-2d5133eacc33',
        label: 'Island',
        customId: 'is'
      },
      {
        id: '9c9225dd-9fc1-c90b-15e0-8edeae25e41b',
        label: 'Israel',
        customId: 'il'
      },
      {
        id: '5112f28e-5499-7589-ae3d-3e0c0fa0d16c',
        label: 'Italien',
        customId: 'it'
      },
      {
        id: 'a4b0b495-2ff1-e9f1-e446-49b83d5fb674',
        label: 'Jamaika',
        customId: 'jm'
      },
      {
        id: '780d5fe1-d1b1-d69a-e8cd-268c906c7258',
        label: 'Japan',
        customId: 'jp'
      },
      {
        id: 'c061552d-ec3e-4667-5e93-b4cb4ef9b53e',
        label: 'Jemen',
        customId: 'ye'
      },
      {
        id: '15a316f5-859c-56ef-96ca-a6d68a9144cc',
        label: 'Jordanien',
        customId: 'jo'
      },
      {
        id: '467fee5d-011e-bd9d-86be-6415c1c2f21d',
        label: 'Kambodscha',
        customId: 'kh'
      },
      {
        id: 'ee70b544-266e-b60c-23a8-ac271679f621',
        label: 'Kamerun',
        customId: 'cm'
      },
      {
        id: 'da4b8020-e347-695c-5cb7-cb32975f2502',
        label: 'Kanada',
        customId: 'ca'
      },
      {
        id: '1dd2bf48-704c-5b7a-c06f-df693da9de0a',
        label: 'Kap Verde',
        customId: 'cv'
      },
      {
        id: '42a5ceb1-3c9c-e3c9-ac03-a814965c14e9',
        label: 'Kasachstan',
        customId: 'kz'
      },
      {
        id: '7af5b049-2e74-ad2d-4ded-af0a04d01c58',
        label: 'Katar',
        customId: 'qa'
      },
      {
        id: '99850026-a770-6554-b24c-0910f4be69f3',
        label: 'Kenia',
        customId: 'ke'
      },
      {
        id: 'baf92040-1883-7fb0-d68f-28a9c35bedb4',
        label: 'Kirgisistan',
        customId: 'kg'
      },
      {
        id: '91bf0cba-ae59-5893-deeb-d5bbf647bf7c',
        label: 'Kiribati',
        customId: 'ki'
      },
      {
        id: 'd4e51327-71ea-7266-1e86-f2cba4ff57ae',
        label: 'Kolumbien',
        customId: 'co'
      },
      {
        id: '6293c169-77c6-6531-4e33-b1bdb4230533',
        label: 'Komoren',
        customId: 'km'
      },
      {
        id: 'c232b70c-b035-0fd9-f7db-90203d93d9b0',
        label: 'Kongo',
        customId: 'cg'
      },
      {
        id: '0705e800-c8f3-551b-d2f0-80d98ad9491f',
        label: 'Kongo, Demokratische Republik',
        customId: 'cd'
      },
      {
        id: '15c00e2a-e6e6-661a-191c-01763d09b8fb',
        label: 'Kosovo',
        customId: 'xk'
      },
      {
        id: 'd9e488f4-8e91-2d36-5490-9dc1723e6313',
        label: 'Kroatien',
        customId: 'hr'
      },
      {
        id: '35e170b8-06df-a6ee-31de-c9a8dcdb0fa0',
        label: 'Kuba',
        customId: 'cu'
      },
      {
        id: 'a9bf9043-62c8-7083-6c4d-2168b4bc4e3d',
        label: 'Kuwait',
        customId: 'kw'
      },
      {
        id: 'b41eec87-9081-1276-a4d3-75c5d6699725',
        label: 'Laos',
        customId: 'la'
      },
      {
        id: '3df95db2-88ec-584c-4c62-a267bb1510f5',
        label: 'Lesotho',
        customId: 'ls'
      },
      {
        id: '867ae256-8373-36d7-28b7-bf7ae71a90a9',
        label: 'Lettland',
        customId: 'lv'
      },
      {
        id: '863c79d3-cc3e-a4a1-d721-b3a3d454e300',
        label: 'Libanon',
        customId: 'lb'
      },
      {
        id: 'c0a3129d-e722-8cd1-3c0e-2c6da5378187',
        label: 'Liberia',
        customId: 'lr'
      },
      {
        id: 'c5773ad5-1ce8-8703-3c7c-302d1d05a917',
        label: 'Libyen',
        customId: 'ly'
      },
      {
        id: 'c8a833cd-67da-4dde-528d-d67a75417b59',
        label: 'Liechtenstein',
        customId: 'li'
      },
      {
        id: '75bfd393-f211-1302-e184-96b9e5a36c50',
        label: 'Litauen',
        customId: 'lt'
      },
      {
        id: '05b65535-78c9-a241-c4d4-2dd6de3b3126',
        label: 'Luxemburg',
        customId: 'lu'
      },
      {
        id: 'd95352c1-d4f1-f5bc-736e-3a3a52db8b27',
        label: 'Madagaskar',
        customId: 'mg'
      },
      {
        id: '25219944-e4fa-0a47-060f-b67bbf186015',
        label: 'Malawi',
        customId: 'mw'
      },
      {
        id: '8f978799-8292-2a43-142b-56a18b0325fb',
        label: 'Malaysia',
        customId: 'my'
      },
      {
        id: '52d6eade-d145-af98-e0ff-d95f2e3a37fc',
        label: 'Malediven',
        customId: 'mv'
      },
      {
        id: 'e30836e8-0520-d437-add2-2da5decb7ccf',
        label: 'Mali',
        customId: 'ml'
      },
      {
        id: '0e1d30a5-9448-bf8b-c636-9d3998cc8492',
        label: 'Malta',
        customId: 'mt'
      },
      {
        id: '13f5bfd1-5f91-193f-b9f2-ae60e6ba252e',
        label: 'Marokko',
        customId: 'ma'
      },
      {
        id: '2b061e05-a8c6-b6d8-b9e8-186fcbe6e075',
        label: 'Marshallinseln',
        customId: 'mh'
      },
      {
        id: 'f939f216-9d88-14e2-a9f5-f4eb21f0106b',
        label: 'Mauretanien',
        customId: 'mr'
      },
      {
        id: 'bc8a3340-649e-61c7-1752-14c43fdd36ca',
        label: 'Mauritius',
        customId: 'mu'
      },
      {
        id: '4fc8dc2c-cd83-d5b8-fc90-879efdab2872',
        label: 'Mexiko',
        customId: 'mx'
      },
      {
        id: '6c68917a-852e-1bb4-e57f-f4d0eb940259',
        label: 'Mikronesien',
        customId: 'fm'
      },
      {
        id: '201042a4-64f9-e27f-7ad2-96c53302aa7c',
        label: 'Moldau',
        customId: 'md'
      },
      {
        id: '6158a22d-f330-8edf-9a94-a520936999a8',
        label: 'Monaco',
        customId: 'mc'
      },
      {
        id: '39738129-660f-16b5-0cdb-429134e80069',
        label: 'Mongolei',
        customId: 'mn'
      },
      {
        id: '660f55ca-048d-4ef4-0282-15db1acc4dff',
        label: 'Montenegro',
        customId: 'me'
      },
      {
        id: 'a958cdef-a527-0f81-0826-7130d77a6b9b',
        label: 'Mosambik',
        customId: 'mz'
      },
      {
        id: '7c6beb72-5e04-f13a-c3e6-f117c86b7fea',
        label: 'Myanmar',
        customId: 'mm'
      },
      {
        id: '4fecc64e-d55a-a531-aee3-35348ab2691a',
        label: 'Namibia',
        customId: 'na'
      },
      {
        id: '242d9de2-de26-f51f-f6ab-9bb726510873',
        label: 'Nauru',
        customId: 'nr'
      },
      {
        id: '796824f0-607c-a870-cb47-beb19869b47c',
        label: 'Nepal',
        customId: 'np'
      },
      {
        id: 'bb2cdfad-0fa9-7c1b-1718-0c4ab17f5d2f',
        label: 'Neuseeland',
        customId: 'nz'
      },
      {
        id: 'aa5983fc-ccac-1921-cd24-cdcdcde16bc4',
        label: 'Nicaragua',
        customId: 'ni'
      },
      {
        id: 'd6b23fbc-88df-e60a-1f7c-5c014ec68e2d',
        label: 'Niederlande',
        customId: 'nl'
      },
      {
        id: 'b73cc31b-c2ea-c140-2e47-5e3c6663edb9',
        label: 'Niger',
        customId: 'ne'
      },
      {
        id: '1eb4defc-38b7-c672-95f6-d9674530834e',
        label: 'Nigeria',
        customId: 'ng'
      },
      {
        id: '5f57ef74-2108-2172-0240-c3f2065cf431',
        label: 'Nordkorea',
        customId: 'kp'
      },
      {
        id: 'ccc78bb7-2c0e-91a7-7b71-d4d1217ecda1',
        label: 'Nordmazedonien',
        customId: 'mk'
      },
      {
        id: 'd29b8753-d35e-5251-b558-413a0eb8b936',
        label: 'Norwegen',
        customId: 'no'
      },
      {
        id: '96deccbb-61a5-46da-8fea-7699b1cf527c',
        label: 'Oman',
        customId: 'om'
      },
      {
        id: 'c3a77de8-6d9b-58f2-3e46-d40439e729d2',
        label: 'Österreich',
        customId: 'at'
      },
      {
        id: '992f9f9d-e8e1-be4f-0da4-04a5ac80c30a',
        label: 'Osttimor',
        customId: 'tl'
      },
      {
        id: '4f7e25be-4fc9-cb75-378a-7f7826a192ee',
        label: 'Pakistan',
        customId: 'pk'
      },
      {
        id: '2e986659-3cea-dcd0-a0e1-99c03e4e197a',
        label: 'Palau',
        customId: 'pw'
      },
      {
        id: '613d9a3f-67ae-c5f4-10eb-d4b981ecb239',
        label: 'Panama',
        customId: 'pa'
      },
      {
        id: '4e5c38e2-85d1-69a8-5da4-6b1ae7374dfd',
        label: 'Papua-Neuguinea',
        customId: 'pg'
      },
      {
        id: 'a0317c89-24ed-c5bb-9458-a3851905b50e',
        label: 'Paraguay',
        customId: 'py'
      },
      {
        id: '861fc2de-2425-4886-56f0-eaac330120e3',
        label: 'Peru',
        customId: 'pe'
      },
      {
        id: '6a4221ae-d8b6-e547-05e8-cbc1426f8f89',
        label: 'Philippinen',
        customId: 'ph'
      },
      {
        id: 'a293578f-6601-1127-af95-3a989810e479',
        label: 'Polen',
        customId: 'pl'
      },
      {
        id: '7e2b02fc-9395-28eb-5323-8c433bc074c7',
        label: 'Portugal',
        customId: 'pt'
      },
      {
        id: 'd49288b6-099b-9c07-bc99-bafc581d7535',
        label: 'Ruanda',
        customId: 'rw'
      },
      {
        id: '1f293aa8-abdc-c9d6-91c0-70b9cfae4643',
        label: 'Rumänien',
        customId: 'ro'
      },
      {
        id: 'db4ce199-dcff-b1e4-61dc-82e52d717aba',
        label: 'Russland',
        customId: 'ru'
      },
      {
        id: '1fe742c0-b42b-3c93-83b4-ddb1ef7900e6',
        label: 'Salomonen',
        customId: 'sb'
      },
      {
        id: '82ec4ede-8fd4-8aa7-ba2e-ef50ce844210',
        label: 'Sambia',
        customId: 'zm'
      },
      {
        id: 'd35e9add-42f1-412f-7df5-467bd23747d7',
        label: 'Samoa',
        customId: 'ws'
      },
      {
        id: 'fed23b23-2668-ecd2-254e-f6077ea40bc1',
        label: 'San Marino',
        customId: 'sm'
      },
      {
        id: 'dab39365-bc9b-c21f-703d-1b06db3f24da',
        label: 'São Tomé und Príncipe',
        customId: 'st'
      },
      {
        id: '5ee2c6da-d65d-61f4-cb23-6c39552309d4',
        label: 'Saudi-Arabien',
        customId: 'sa'
      },
      {
        id: '6215b6bb-462b-a36d-1dc2-69a9042fc6f2',
        label: 'Schweden',
        customId: 'se'
      },
      {
        id: 'c19c3115-39be-86ce-a611-b65d5367e50f',
        label: 'Schweiz',
        customId: 'ch'
      },
      {
        id: '6ef7ee80-b661-f4a1-a38a-7d18c2b803d8',
        label: 'Senegal',
        customId: 'sn'
      },
      {
        id: '0ec6e6c6-95ab-7c5e-cde5-3239efa6dda6',
        label: 'Serbien',
        customId: 'rs'
      },
      {
        id: '22ee86c2-3396-52d1-cd12-93bc1e8cb1fd',
        label: 'Seychellen',
        customId: 'sc'
      },
      {
        id: 'f88bd4f3-fda7-ea45-6d10-c0dc049fb024',
        label: 'Sierra Leone',
        customId: 'sl'
      },
      {
        id: '9db70ba6-195d-10a4-bce0-8de8ce03880a',
        label: 'Simbabwe',
        customId: 'zw'
      },
      {
        id: '9d138320-5b99-8069-05ca-b4922c1d4e47',
        label: 'Singapur',
        customId: 'sg'
      },
      {
        id: '5e8f8970-e67b-2465-22c1-47b9869c2eb7',
        label: 'Slowakei',
        customId: 'sk'
      },
      {
        id: '8d98f6f2-07b7-2984-011f-97a7b7040ced',
        label: 'Slowenien',
        customId: 'si'
      },
      {
        id: '095c60ff-006c-301b-ff94-5ada5f47e938',
        label: 'Somalia',
        customId: 'so'
      },
      {
        id: 'fa332f0e-4bb3-108d-f0c5-6ca8a6089c57',
        label: 'Spanien',
        customId: 'es'
      },
      {
        id: '3a6094cb-2729-055c-d5f9-a8b8bf9f3a53',
        label: 'Sri Lanka',
        customId: 'lk'
      },
      {
        id: 'c226c0b8-4871-26e5-d679-3dcc223ac6e0',
        label: 'St. Kitts und Nevis',
        customId: 'kn'
      },
      {
        id: '2764e3b3-821a-98d2-70ee-df6c17aef2f6',
        label: 'St. Lucia',
        customId: 'lc'
      },
      {
        id: '23a4a7da-0a3f-2924-599e-0fb2f6c291a5',
        label: 'St. Vincent und die Grenadinen',
        customId: 'vc'
      },
      {
        id: '6c0f46b2-05ee-9065-4f1b-21a3141bb7bc',
        label: 'Südafrika',
        customId: 'za'
      },
      {
        id: '8ca08b29-71c9-658b-8601-d699a16d32cb',
        label: 'Sudan',
        customId: 'sd'
      },
      {
        id: 'a8d013dd-1b9b-d8a5-725a-b4650f7d491b',
        label: 'Südkorea',
        customId: 'kr'
      },
      {
        id: '76030eff-cf18-a952-82ca-fc0942ec7082',
        label: 'Südsudan',
        customId: 'ss'
      },
      {
        id: 'cd3df5de-657a-bf25-d81c-7a8a4b3d67bc',
        label: 'Suriname',
        customId: 'sr'
      },
      {
        id: '025f4f2e-8b33-9da5-1145-3ee711061f67',
        label: 'Syrien',
        customId: 'sy'
      },
      {
        id: 'd91dc2c3-2918-6401-bc3f-77f0a824f3fd',
        label: 'Tadschikistan',
        customId: 'tj'
      },
      {
        id: '6e85252e-8def-4c9b-5ce7-6c810b456397',
        label: 'Tansania',
        customId: 'tz'
      },
      {
        id: 'd7322c1f-ccd5-1120-2600-666ba5809998',
        label: 'Thailand',
        customId: 'th'
      },
      {
        id: '625352af-bfde-1e66-2f33-e9bcdfe3b117',
        label: 'Togo',
        customId: 'tg'
      },
      {
        id: '9fc72e31-87c4-2480-88b8-accc329ece82',
        label: 'Tonga',
        customId: 'to'
      },
      {
        id: 'fe0af013-025b-da23-e09e-4d6cda010cce',
        label: 'Trinidad und Tobago',
        customId: 'tt'
      },
      {
        id: '62fd2637-3524-780f-1d28-1f796003a613',
        label: 'Tschad',
        customId: 'td'
      },
      {
        id: '42011ef9-0a30-3278-9b39-763a1550bf94',
        label: 'Tschechien',
        customId: 'cz'
      },
      {
        id: 'a9c4779d-0120-7245-2e9c-fd8cf40fdfa8',
        label: 'Tunesien',
        customId: 'tn'
      },
      {
        id: '3540f260-62bb-9c42-1428-5690be2f713b',
        label: 'Türkei',
        customId: 'tr'
      },
      {
        id: '14a6b51b-571c-83a9-3d23-23aa03f28e13',
        label: 'Turkmenistan',
        customId: 'tm'
      },
      {
        id: '5d7dec21-56b5-5fe7-c4f1-480e3cd7f14b',
        label: 'Tuvalu',
        customId: 'tv'
      },
      {
        id: '1918cf2c-e6ab-4299-d3fc-be7bea80fc03',
        label: 'Uganda',
        customId: 'ug'
      },
      {
        id: '1dc412c7-ecee-fefa-3fde-236a0b84ebda',
        label: 'Ukraine',
        customId: 'ua'
      },
      {
        id: 'c8f17efd-ba55-0ed0-30df-f60558f78b91',
        label: 'Ungarn',
        customId: 'hu'
      },
      {
        id: 'dceaa497-9271-d516-7aa0-2efe11ffcea5',
        label: 'Uruguay',
        customId: 'uy'
      },
      {
        id: 'b825c52b-9171-1858-be64-485f54e0e2b1',
        label: 'Usbekistan',
        customId: 'uz'
      },
      {
        id: '2fe456c1-23a0-b961-080c-7e895f70c34b',
        label: 'Vanuatu',
        customId: 'vu'
      },
      {
        id: 'cc714668-95c4-1c24-a597-45f06ecea514',
        label: 'Vatikanstadt',
        customId: 'va'
      },
      {
        id: '0723546d-b9c2-21da-df0b-089d3911a676',
        label: 'Venezuela',
        customId: 've'
      },
      {
        id: '7b011331-d531-9e97-ced0-4f43941600b5',
        label: 'Vereinigte Arabische Emirate',
        customId: 'ae'
      },
      {
        id: '5656b4cb-256e-df52-c7f3-247e44bc3aff',
        label: 'Vereinigte Staaten',
        customId: 'us'
      },
      {
        id: '43e0b533-f72b-0db4-3b22-864429734c98',
        label: 'Vereinigtes Königreich',
        customId: 'gb'
      },
      {
        id: '85efe561-1a65-435b-7074-b16cb89be024',
        label: 'Vietnam',
        customId: 'vn'
      },
      {
        id: 'd4ca72c6-a130-f746-cc91-e868c24d5373',
        label: 'Weißrussland',
        customId: 'by'
      },
      {
        id: '547f6555-3fe8-6283-9cb3-439ada495921',
        label: 'Zentralafrikanische Republik',
        customId: 'cf'
      },
      {
        id: '41287a12-aae3-9002-31c7-f666b7a487b2',
        label: 'Zypern',
        customId: 'cy'
      }
    ]
  }
];
